<template>
  <span :style="{ color: color }"><slot></slot></span>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

const map = {
  default: "#505050",
  primary: "#2F7BFF",
  success: "#299F4C",
  warning: "#FA9D37",
  danger: "#E62C2B",
};

export default defineComponent({
  isGlobal: true,
  name: "HmdFont",
  props: {
    type: {
      type: String,
      default: "default",
    },
  },
  setup(props, { attrs, slots, emit }) {
    const color = ref(map[props.type]);
    return { color };
  },
});
</script>
